export const REQUEST_TOKEN_STATUS = 'REQUEST_TOKEN_STATUS';
export const REQUEST_TOKEN_FAILURE = 'REQUEST_TOKEN_FAILURE';
export const IS_REQUESTING_TOKEN = 'IS_REQUESTING_TOKEN';
